/* eslint-disable react-hooks/rules-of-hooks */
// ⚠ Même situation qu'AtelierV2 : le plugin 1.7.0 (CRA 3) dépasse sa limite
// de chemins sur ce composant — faux positif, pas un vrai problème de hooks.
import React, { useEffect, useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faArrowLeft,
	faBoxOpen,
	faCar,
	faCrown,
	faFileAlt,
	faLongArrowAltRight,
	faPlay,
	faPlus,
	faStar,
	faTools,
	faTrash,
	faTruck,
} from "@fortawesome/free-solid-svg-icons"
import { COLORS } from "../../utilities/Constants"
import { generalStyles as gs } from "../styles/styles"
import Loader from "../basics/Loader"
import CustomModal, {
	LoadingCustomModal,
} from "../basics/interface/CustomModal"
import CollapsibleCardV2 from "../basics/interface/CollapsibleCardV2"
import useQuitGuard from "../../hooks/useQuitGuard"
import useRelectureMedias from "../../hooks/useRelectureMedias"
import useFicheVerrou from "../../hooks/useFicheVerrou"
import useFeuilletage from "../../hooks/useFeuilletage"
import {
	BandeauFicheClose,
	BandeauLectureSeule,
	BoutonDemanderMain,
} from "../others/FicheVerrou"
import { verrouFicheClose } from "../../utilities/ficheClose"
import {
	manquantsClotureDepannage,
	autresEtatsDepannage,
	etapeSuivanteDepannage,
	libelleAutreEtat,
} from "../../utilities/etatsFiche"
import MenuEtatFicheV2 from "../others/MenuEtatFicheV2"
import { marqueurFicheLiee } from "../../utilities/ficheLiee"
import FacturationModalV2, {
	compterNonEnregistrees,
} from "../others/FacturationModalV2"
import { PAYE_PAR_MASTER } from "../atelier/AtelierLigneV2"
import { getOpenerId } from "../../utilities/session"
import { useRights } from "../../hooks/rights"
import useDepFiche from "./useDepFiche"
import {
	checkAvertissements,
	checkErrors,
	round2,
	sectionStatus,
} from "./depFicheUtils"
import BandeauFicheIncomplete from "./BandeauFicheIncomplete"
import EmailModalV2 from "../others/EmailModalV2"
import {
	EMAIL_DOMAINE_DEPANNAGE,
	fetchEmails,
} from "../../store/actions/emailActions"
import EmailListV2 from "../others/EmailListV2"
import {
	DEPANNAGE_TYPE_APPEL_POLICE,
	DIAGNOSTIQUE_POLICE_LABELS,
	DEPANNAGE_ETAT_DICT,
	DEPANNAGE_ETAT_BADGE,
	DEPANNAGE_ETAT_EN_COURS,
	DEPANNAGE_ETAT_ANNULE,
	DEPANNAGE_ETAT_CLOS,
	DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT,
	DEPANNAGE_ETAT_OK_POUR_FACTURATION,
	DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION,
	DEP_STATES,
	EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
	EMAIL_DESTINATAIRE_EXPERT,
	EMAIL_DESTINATAIRE_LIBRE,
	normalizePdf,
} from "../../utilities/Addons"
import { showToast, toastApiError } from "../../store/actions/toastActions"
import { catchApiError, handleErrors } from "../../store/actions/apiHelpers"
import DepLivraisonMissionModal from "./DepLivraisonMissionModal"
import { echapIgnoreParFiche } from "../../utilities/echapFiche"
import {
	URL,
	fetchDepToLocation,
	postDepannage,
	postDepannageErrorField,
	postDepannageReset,
} from "../../store/actions/depannageActions"
import { depFiche } from "../PDF/DepFiche"
import { VEHICULE_CATEGORIE } from "../../utilities/Utils"
import TransactionsCardV2 from "../others/TransactionsCardV2"
import { annonceFacture, texteEcart } from "./annonceFacture"
import HistoriqueCardV2 from "../others/HistoriqueCardV2"
import { refusAnnulationTerrain } from "./transactionsDep"
import {
	BOSS,
	causeNonSupprimable,
	champsModifiables,
	consequencesTransactions,
	EMPLOYE,
	niveauTransactions,
	regleDatation,
} from "../../utilities/transactionsV2"
import DepFicheInterventionV2 from "./DepFicheInterventionV2"
import CouverturesCarte, {
	ANCRE_COUVERTURES,
	defilerVersCouvertures,
	ligneCouvert,
	useCouvertures,
} from "./couvertures/CouverturesCarte"
import DepFicheTrajetV2 from "./DepFicheTrajetV2"
import DepFicheClientV2 from "./DepFicheClientV2"
import DepFicheVehiculeV2 from "./DepFicheVehiculeV2"
import DepFicheSinistresV2 from "./DepFicheSinistresV2"
import DepFicheTarifsV2 from "./DepFicheTarifsV2"
import { downloadPdfFromResponse } from "../basics/button/AppBtnDownloadPdf"
import SaveDepFicheV2 from "./SaveDepFicheV2"
import DepLivrerRestituerModalV2 from "./DepLivrerRestituerModalV2"
import { configHorsHeures } from "./livrerRestituer"
import { DepToLocation } from "./DepToLocation"
import FileDisplayer, { VIDEO_EXTS } from "../others/FileDisplayer"
import { POINT_INTERET_TYPE_ATELIER } from "../others/PointInteretComponent"
import "./DepFicheV2.css"

// Interrupteur (repris du design fiche atelier) pour le drapeau Boss en tête.
const Switch = ({
	on,
	onClick,
	title,
	disabled = false,
	color = COLORS.success,
}) => (
	<button
		type="button"
		role="switch"
		aria-checked={on}
		onClick={onClick}
		disabled={disabled}
		title={title}
		style={{
			width: 46,
			height: 26,
			borderRadius: 99,
			border: "none",
			padding: 0,
			position: "relative",
			cursor: disabled ? "not-allowed" : "pointer",
			backgroundColor: on ? color : COLORS.border,
			transition: "background-color 0.15s",
			flexShrink: 0,
			opacity: disabled ? 0.5 : 1,
		}}
	>
		<span
			style={{
				position: "absolute",
				top: 3,
				left: on ? 23 : 3,
				width: 20,
				height: 20,
				borderRadius: "50%",
				backgroundColor: "#fff",
				transition: "left 0.15s",
				boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
			}}
		/>
	</button>
)

const styles = {
	// GE-60 : sous-ligne « dont couvert par … » du bandeau (cliquable).
	ligneCouvert: {
		...gs.statSub,
		display: "block",
		padding: 0,
		border: 0,
		background: "none",
		textAlign: "left",
		cursor: "pointer",
		fontFamily: "inherit",
		textDecoration: "underline dotted",
		textUnderlineOffset: 3,
	},
	back: {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		width: 38,
		height: 38,
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.surface,
		color: COLORS.text,
		cursor: "pointer",
		flexShrink: 0,
	},
	kicker: {
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: "0.06em",
		textTransform: "uppercase",
		color: COLORS.textLight,
	},
	title: {
		fontSize: 22,
		fontWeight: 600,
		letterSpacing: "-0.01em",
		color: COLORS.text,
		marginTop: 2,
	},
	// Chip cliquable (Marquer, Imprimer une note) : état actif teinté.
	chip: (active, color, bg) => ({
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		padding: "6px 14px",
		borderRadius: 99,
		border: `1px solid ${active ? color : COLORS.border}`,
		backgroundColor: active ? bg : COLORS.surface,
		color: active ? color : COLORS.textMuted,
		fontSize: 12,
		fontWeight: 600,
		cursor: "pointer",
		fontFamily: "inherit",
		flexShrink: 0,
	}),
	// Micro-libellé de la bande de mission.
	micro: {
		fontSize: 10,
		fontWeight: 600,
		color: COLORS.textLight,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		marginBottom: 3,
	},
	stripValue: {
		fontSize: 15,
		fontWeight: 600,
		color: COLORS.text,
		fontVariantNumeric: "tabular-nums",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	// Largeur max de la fiche : évite l'étalement plein écran sur grand moniteur.
	// Le padding bas dégage le footer fixe (gs.fixedFooter) qui flotte sur le
	// contenu.
	content: { maxWidth: 1600, margin: "0 auto", paddingBottom: 80 },
	// Lecture seule : un <fieldset disabled> désactive NATIVEMENT tout ce qu'il
	// contient (inputs, selects, textareas, boutons), sans avoir à faire
	// descendre un `disabled` dans chaque carte et chaque composant partagé —
	// et sans risque d'en oublier un. Ces styles neutralisent l'apparence par
	// défaut du fieldset, qui ne doit rien changer à la mise en page.
	fieldset: { border: 0, padding: 0, margin: 0, minWidth: 0 },
	// GE-80 : carte de la ligne Sinistres | Diagnostique | E-mails dans son
	// propre fieldset (la carte prend toute la hauteur de la ligne).
	fieldsetCarte: {
		border: 0,
		padding: 0,
		margin: 0,
		minWidth: 0,
		display: "flex",
		flexDirection: "column",
	},
	filePreview: { margin: 6, cursor: "pointer", borderRadius: 8 },
	// Rond play semi-transparent centré sur la vignette vidéo.
	fileVideoOverlay: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: 32,
		height: 32,
		borderRadius: "50%",
		background: "rgba(0, 0, 0, 0.45)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		paddingLeft: 2, // recentre optiquement le triangle play
	},
	// Taille du fichier en bandeau bas de la vignette vidéo.
	fileVideoCaption: {
		position: "absolute",
		bottom: 0,
		left: 0,
		right: 0,
		fontSize: 9,
		lineHeight: "14px",
		color: "#fff",
		background: "rgba(0, 0, 0, 0.45)",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	// Indicateur footer : une livraison existe pour cette fiche (état inclus).
	livraisonChip: {
		display: "inline-flex",
		alignItems: "center",
		gap: 8,
		padding: "0 14px",
		height: 38,
		borderRadius: 10,
		fontSize: 13,
		fontWeight: 600,
		color: "#0F766E",
		backgroundColor: "#CCFBF1",
	},
	fileColTitle: {
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		marginBottom: 8,
	},
	fileRow: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "center",
	},
}

// Libellé court d'un point d'intérêt (lieu / destination), tolérant aux deux
// formes de données (POI serveur {label, adresse} et base dep {ligne_0}).
const poiText = (po) => {
	if (!po) return "—"
	if (po.label) return po.label
	if (
		po.adresse &&
		`${po.adresse.rue || ""}${po.adresse.numero || ""}` !== ""
	)
		return `${po.adresse.rue} ${po.adresse.numero}`.trim()
	if (po.ligne_0) return po.ligne_0
	return "—"
}
const poiTooltip = (po) =>
	po && po.adresse
		? `${po.adresse.rue} ${po.adresse.numero}, ${po.adresse.code_postal} ${po.adresse.localite}`
		: undefined

// Type Parc (miroir PointInteretComponent) — garde livraison + détection
// « jamais saisi ».
const POI_TYPE_PARC = 0
const POI_TYPE_ATELIER = POINT_INTERET_TYPE_ATELIER

// POI « jamais saisi » (round-trip du PointInteret.get_base serveur : ni id,
// ni label, type Parc par défaut) — c'est la forme que prend une destination
// déclarée inconnue (NULL en base). Aligné sur DepMissionV2.
const estPoJamaisSaisi = (po) =>
	!po || (po.id === null && !po.label && po.type === POI_TYPE_PARC)

// Valeur + tooltip « Destination » de la bande de mission. Hors composant
// EXPRÈS : au-delà d'un certain nombre de branches dans DepFicheV2, le vieux
// plugin rules-of-hooks de CRA 3 sort des faux positifs sur les hooks (deux
// ternaires de plus suffisaient) — les branches d'une fonction externe ne
// comptent pas dans son graphe.
const destinationStrip = (dep, destinationInconnue) =>
	dep.surPlace
		? { valeur: "Sur place", title: "Dépanné sur place" }
		: destinationInconnue
			? {
					valeur: "Inconnue",
					title: "Destination non renseignée sur cette fiche",
				}
			: {
					valeur: poiText(dep.destination_finale),
					title: poiTooltip(dep.destination_finale),
				}

// Destinataires proposés au modal e-mail : le client de la fiche (e-mail
// copié de la mission ou complété après coup, GE-46). GE-81 (Jordan 30.10) :
// + l'expert s'il vient de la base et a un e-mail, + une adresse libre (pas
// d'« Assurance » : texte libre sur le dépannage, sans adresse).
const destinatairesEmail = (email, expert) => [
	{
		type: EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
		email: email || "",
		label: "Client",
	},
	...(expert && expert.email
		? [
				{
					type: EMAIL_DESTINATAIRE_EXPERT,
					email: expert.email,
					label: "Expert",
				},
			]
		: []),
	{ type: EMAIL_DESTINATAIRE_LIBRE, email: "", label: "Libre" },
]

// Modal « raison » avant l'ajout d'une transaction (copie du pattern
// atelier/AddTransactionModalV2, remplace others/AddTransactionModal).
const AddDepTransactionModalV2 = ({ onClose, addTransaction }) => {
	const [raison, setRaison] = useState("")
	const inputRef = useRef(null)
	useEffect(() => {
		if (inputRef.current) inputRef.current.focus()
	}, [])
	const clickOk = () => {
		addTransaction(raison)
		onClose()
	}
	return (
		<CustomModal
			title="Nouvelle transaction"
			onClose={onClose}
			buttons={[
				{ title: "Fermer", styleName: "secondary", onClick: onClose },
				{
					title: "Ajouter",
					styleName: "primary",
					onClick: clickOk,
					disabled: raison === "",
				},
			]}
		>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Raison</label>
				<input
					ref={inputRef}
					type="text"
					style={gs.input}
					value={raison}
					onChange={(e) => setRaison(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter" && raison !== "") clickOk()
					}}
				/>
			</div>
		</CustomModal>
	)
}

// ─── Chronologie de l'intervention (droit « stats ») ───
// GE-49 : création + DERNIER dispatch de la mission (mission_chrono du
// serializer, null pour une fiche saisie au bureau), puis les jalons
// terrain recopiés de la mission à la conversion — sémantique 4 temps
// (07.2026) : t2 = départ du lieu, t3 = arrivée à destination (transports
// réels uniquement, un sur-place s'arrête à t2).
const JALONS_CHRONO = [
	{ key: "creation", label: "Création" },
	{ key: "dispatch", label: "Dispatch" },
	{ key: "timestamp_0", label: "Départ vers le lieu" },
	{ key: "timestamp_1", label: "Arrivée sur le lieu" },
	{ key: "timestamp_2", label: "Départ du lieu" },
	{ key: "timestamp_3", label: "Arrivée à destination" },
]

// "dd-mm-yyyy HH:MM" (format serializer) → Date, null si absent/malformé.
const parseTsChrono = (ts) => {
	if (!ts) return null
	const [date, heure] = ts.split(" ")
	if (!date || !heure) return null
	const [jj, mm, aaaa] = date.split("-")
	const d = new Date(`${aaaa}-${mm}-${jj}T${heure}:00`)
	return isNaN(d.getTime()) ? null : d
}

const formatDureeChrono = (ms) => {
	if (ms === null || ms < 0) return "—"
	const min = Math.round(ms / 60000)
	const h = Math.floor(min / 60)
	return h > 0 ? `${h} h ${String(min % 60).padStart(2, "0")}` : `${min} min`
}

const chronoStyles = {
	label: { fontSize: 13, color: COLORS.textLight },
	valeur: { fontSize: 13, fontVariantNumeric: "tabular-nums" },
	// « Qui » sous la valeur d'un jalon (GE-49).
	qui: {
		display: "block",
		fontSize: 11,
		color: COLORS.textLight,
		fontVariantNumeric: "normal",
	},
	duree: {
		fontSize: 13,
		fontWeight: 600,
		fontVariantNumeric: "tabular-nums",
	},
	separateur: {
		height: 1,
		backgroundColor: COLORS.border,
		margin: "8px 0",
	},
}

const DUREES_CHRONO_LABELS = [
	"Prise en charge bureau",
	"Délai de départ",
	"Trajet aller",
	"Sur place",
	"Transport",
]
// Index de « Prise en charge bureau » (sans objet hors appel) et de « Délai
// de départ » (marqué RDV : long par construction).
const DUREE_BUREAU = 0
const DUREE_DELAI_DEPART = 1

// Valeur + « qui » d'un jalon : création / dispatch depuis mission_chrono,
// t0→t3 depuis le porteur, faits par le dépanneur.
const jalonChrono = (j, src, depanneurNom) => {
	const mc = src.mission_chrono || {}
	if (j.key === "creation") return { brut: mc.cree_le, qui: mc.createur }
	if (j.key === "dispatch")
		return { brut: mc.dispatchee_le, qui: mc.dispatcheur, rdv: mc.rdv }
	return { brut: src[j.key], qui: src[j.key] ? depanneurNom : null }
}

// Jalons + durées dérivées d'un porteur (dep ou livraison). Total compté
// depuis la création si connue, sinon depuis le départ (t0).
const colonneChrono = (src, depanneurNom) => {
	const jalons = JALONS_CHRONO.map((j) => {
		const v = jalonChrono(j, src, depanneurNom)
		return { ...j, ...v, date: parseTsChrono(v.brut) }
	})
	const [cr, di, t0, t1, t2, t3] = jalons.map((j) => j.date)
	const ecart = (a, b) => (a && b ? b - a : null)
	// Livraison / suite SvpCentral : la création n'est pas un appel → pas
	// de prise en charge bureau, total compté depuis le départ.
	const raisonBureau = (src.mission_chrono || {}).sans_prise_en_charge
	const debut = raisonBureau ? t0 : cr || t0
	const dernierJalon = [...jalons].reverse().find((j) => j.date)
	return {
		jalons,
		rdv: !!(src.mission_chrono || {}).rdv,
		raisonBureau,
		durees: [
			raisonBureau ? null : ecart(cr, di),
			ecart(di, t0),
			ecart(t0, t1),
			ecart(t1, t2),
			ecart(t2, t3),
		],
		totale: debut && dernierJalon ? dernierJalon.date - debut : null,
	}
}

const nomEmploye = (employes, id) => {
	const e = (employes || []).find((emp) => emp.id === id)
	return e ? e.nom : null
}

const badgeRdv = (
	<span
		style={{
			marginLeft: 6,
			padding: "1px 6px",
			borderRadius: 99,
			fontSize: 10,
			fontWeight: 600,
			color: COLORS.accent,
			backgroundColor: COLORS.accentLight,
		}}
		title="Mission sur rendez-vous : le délai dispatch → départ est long par construction"
	>
		RDV
	</span>
)

// Modal read-only : les 6 jalons dans l'ordre chronologique (création,
// dispatch, t0→t3) avec QUI, les durées dérivées (bureau, délai de départ,
// aller / sur place / transport) et la durée totale. Avec
// livraisons : tableau récapitulatif, une colonne par trajet (intervention
// puis livraisons chronologiques, n° = index serveur comme dans Tarifs).
const ChronoModal = ({ dep, employes, onClose }) => {
	const colonnes = [
		{
			titre: "Intervention",
			sous: "",
			...colonneChrono(dep, nomEmploye(employes, dep.depanneur)),
		},
		...(dep.livraisons || [])
			.map((liv, index) => ({ liv, numero: index + 1 }))
			.sort((a, b) =>
				(a.liv.datetime || "9999").localeCompare(
					b.liv.datetime || "9999",
				),
			)
			.map(({ liv, numero }) => ({
				titre: `Livraison ${numero}`,
				sous: poiText(liv.destination_adresse),
				...colonneChrono(liv, nomEmploye(employes, liv.employe)),
			})),
	]
	// Fiche annulée : le dernier jalon non-null de l'intervention est le moment
	// de l'annulation (règle « prochain jalon null » posée par le mobile).
	if (dep.etat === DEPANNAGE_ETAT_ANNULE) {
		const poses = colonnes[0].jalons.filter(
			(j) => j.date && j.key.startsWith("timestamp"),
		)
		if (poses.length > 0) {
			poses[poses.length - 1].label = "Annulé"
		}
	}
	const multi = colonnes.length > 1
	const grille = {
		display: "grid",
		gridTemplateColumns: `minmax(120px, auto) repeat(${colonnes.length}, minmax(${multi ? 150 : 130}px, 1fr))`,
		columnGap: 20,
		alignItems: "baseline",
	}
	const celluleValeur = { textAlign: "right", padding: "6px 2px" }
	const pleineLargeur = { gridColumn: "1 / -1" }
	return (
		<CustomModal
			title="Chronologie de l'intervention"
			onClose={onClose}
			maxWidth={multi ? 240 + colonnes.length * 190 : null}
			buttons={[
				{ title: "Fermer", styleName: "secondary", onClick: onClose },
			]}
		>
			<div style={grille}>
				{multi && (
					<>
						<span />
						{colonnes.map((c) => (
							<div
								key={`tete_${c.titre}`}
								style={{
									...celluleValeur,
									paddingBottom: 10,
								}}
							>
								<div
									style={{
										fontSize: 13,
										fontWeight: 600,
									}}
								>
									{c.titre !== "Intervention" && (
										<FontAwesomeIcon
											icon={faTruck}
											style={{
												fontSize: 11,
												color: COLORS.textLight,
												marginRight: 6,
											}}
										/>
									)}
									{c.titre}
								</div>
								{c.sous && c.sous !== "—" && (
									<div
										style={{
											fontSize: 11,
											color: COLORS.textLight,
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap",
										}}
									>
										{c.sous}
									</div>
								)}
							</div>
						))}
					</>
				)}
				{JALONS_CHRONO.map((jalon, ligne) => (
					<React.Fragment key={jalon.key}>
						<span
							style={{
								...chronoStyles.label,
								padding: "6px 2px",
							}}
						>
							{colonnes[0].jalons[ligne].label}
						</span>
						{colonnes.map((c, i) => (
							<span
								key={`j_${jalon.key}_${i}`}
								style={{
									...chronoStyles.valeur,
									...celluleValeur,
								}}
							>
								{c.jalons[ligne].brut || "—"}
								{c.jalons[ligne].brut && c.jalons[ligne].rdv
									? badgeRdv
									: null}
								{c.jalons[ligne].qui ? (
									<span style={chronoStyles.qui}>
										{c.jalons[ligne].qui}
									</span>
								) : null}
							</span>
						))}
					</React.Fragment>
				))}
				<div style={{ ...chronoStyles.separateur, ...pleineLargeur }} />
				{DUREES_CHRONO_LABELS.map((label, ligne) => (
					<React.Fragment key={label}>
						<span
							style={{
								...chronoStyles.label,
								padding: "6px 2px",
							}}
						>
							{label}
						</span>
						{colonnes.map((c, i) => (
							<span
								key={`d_${label}_${i}`}
								style={{
									...chronoStyles.duree,
									...celluleValeur,
								}}
								title={
									(ligne === DUREE_BUREAU &&
										c.raisonBureau) ||
									undefined
								}
							>
								{formatDureeChrono(c.durees[ligne])}
								{ligne === DUREE_DELAI_DEPART &&
								c.rdv &&
								c.durees[ligne] !== null
									? badgeRdv
									: null}
							</span>
						))}
					</React.Fragment>
				))}
				<div style={{ ...chronoStyles.separateur, ...pleineLargeur }} />
				<span
					style={{
						...chronoStyles.label,
						fontWeight: 600,
						padding: "6px 2px",
					}}
				>
					Durée totale
				</span>
				{colonnes.map((c, i) => (
					<span
						key={`t_${i}`}
						style={{ ...chronoStyles.duree, ...celluleValeur }}
					>
						{formatDureeChrono(c.totale)}
					</span>
				))}
			</div>
		</CustomModal>
	)
}

/**
 * Fiche dépannage V2 — rework visuel de DepFiche.js (legacy conservé dans le
 * repo). Même slice redux, même payload. Les flux « Matériel », dépannage →
 * atelier (svpMeca post-save) et livraisons ne sont pas portés : ils passent
 * par l'application mobile.
 */

// Bandeau « Reste à payer » avec couvertures (maquette GE-60) : la valeur est
// le reste CLIENT (vert à 0, orange si le plafond est inférieur au total),
// la sous-ligne « dont couvert par … » défile jusqu'à la carte.
const resteBandeau = (restePayer, couvert) => {
	if (!couvert || !couvert.precise)
		return {
			valeur: restePayer,
			couleur: restePayer > 0 ? COLORS.danger : COLORS.success,
		}
	const valeur = Math.min(restePayer, couvert.resteClient || 0)
	return {
		valeur: round2(valeur),
		couleur:
			valeur <= 0
				? COLORS.success
				: couvert.partiel
					? COLORS.warning
					: COLORS.danger,
	}
}

// Jordan 19.10 : conséquences à confirmer avant le save (documents
// archivés ; garde-fous du boss : WinBIZ, rapprochement, fiche close) — les
// lignes supprimées sont relues dans la fiche telle que chargée (`_charge`).
const consequencesSaveDep = (dep, charge) =>
	consequencesTransactions({
		transactions: dep.transactionsv2,
		supprimees: ((charge && charge.transactionsv2) || []).filter((t) =>
			(dep.transactions_supprimees || []).includes(t.id),
		),
		close: !!charge && charge.etat === DEPANNAGE_ETAT_CLOS,
	})

// GE-75 (Jordan 19.10) : ligne discrète sous le total des lignes privées —
// « Annoncé : sur place X / transporté Y · Facturé : Z », écart en couleur.
// Module-level (seuil rules-of-hooks de CRA 3).
const ligneAnnonce = (annonce, facture) => {
	const a = annonceFacture(annonce, facture)
	if (!a) return null
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "flex-end",
				gap: 6,
				fontSize: 12,
				color: COLORS.textMuted,
			}}
		>
			<span>{a.texte}</span>
			{a.ecart !== null && (
				<span style={{ color: COLORS.warning, fontWeight: 600 }}>
					· {texteEcart(a.ecart)}
				</span>
			)}
		</div>
	)
}

// Fc6 (Jordan 12.10) : boutons « fiche atelier » de la fiche dépannage —
// la fiche liée (dep.atelier), puis les fiches de réparation (GE-69, D2) et
// les fiches fournitures restantes (GE-67, une par mission). Module-level
// (seuil rules-of-hooks de CRA 3).
const boutonsFichesAtelier = (dep) => {
	const fournitures = dep.fiches_fournitures || []
	const reparations = dep.fiches_reparation || []
	// Lot 9 (Jordan 30.10) : boutons icône seule, « Atelier » dans
	// l'infobulle (plus « Réparation »).
	const deFournitures = (f) => ({
		id: f.id,
		fournitures: true,
		title: `Atelier N° ${f.id} — fournitures de la mission M${f.mission}`,
	})
	const deReparation = (r) => ({
		id: r.id,
		fournitures: false,
		title: `Atelier N° ${r.id} — mission M${r.mission}${r.site ? ` (site ${r.site})` : ""}`,
	})
	const boutons = []
	if (dep.atelier > 0) {
		const liee = fournitures.find((f) => f.id === dep.atelier)
		const reparation = reparations.find((r) => r.id === dep.atelier)
		boutons.push(
			liee
				? deFournitures(liee)
				: reparation
					? deReparation(reparation)
					: {
							id: dep.atelier,
							fournitures: false,
							title: `Atelier N° ${dep.atelier}`,
						},
		)
	}
	reparations
		.filter((r) => r.id !== dep.atelier)
		.forEach((r) => boutons.push(deReparation(r)))
	fournitures
		.filter((f) => f.id !== dep.atelier)
		.forEach((f) => boutons.push(deFournitures(f)))
	return boutons
}

const DepFicheV2 = () => {
	const { id: urlId } = useParams()
	const location = useLocation()
	const history = useHistory()
	const dispatch = useDispatch()
	const { canQuit, setDirty, setClean, QuitGuard } = useQuitGuard()
	const fiche = useDepFiche({ setDirty, setClean })
	const { depInfo, dep, employes, moyenPaiements, mdpFacture, restePayer } =
		fiche
	// Revue 6 (M2) : lien média expiré → la fiche (non modifiée) se relit.
	const onMediaError = useRelectureMedias(dep.id, canQuit, fiche.loadDep)
	const navLogin = useSelector((s) => s.navInfo.login)
	// Lot 7 : frais de restitution hors heures (tarification de l'entreprise).
	const masterEntite = useSelector((s) => s.masterReducer.masterEntite)
	// GE-81 : experts de la base (fetchAutreEntites, useDepFiche).
	const experts = useSelector((s) => s.autreInfo.experts)
	const isBoss = navLogin.groups.includes("boss")
	// Jordan 19.10 : une règle de modification des transactions pour les 3
	// fiches (utilities/transactionsV2) ; responsable du module, fiche
	// enregistrée (Jordan 30.10).
	const ficheCompta = {
		module: "depannage",
		etat:
			dep.id > 0 && depInfo.depCharge?.id === dep.id
				? depInfo.depCharge.etat
				: undefined,
	}
	const niveau = niveauTransactions({
		isBoss,
		isAdmin: navLogin.groups.includes("admin"),
		groupes: navLogin.groups,
		...ficheCompta,
	})
	// Résultats de la dernière recherche : destination d'Échap (tableau s'il y
	// en a, formulaire sinon — règle commune aux 3 fiches).
	const { deps: searchDeps, livs: searchLivs } = useSelector(
		(s) => s.depSearchInfo,
	)
	// Chronologie des jalons terrain : réservée au droit « stats » (boss).
	const { hasRight } = useRights()
	const peutVoirChrono = hasRight("stats")
	// GE-60 : couvertures de la fiche (carte + bandeau « Reste à payer »).
	// Rechargée après chaque sauvegarde, encaissement ou proposition
	// appliquée (revue 08.10, I2 / I11) — pas sur la saisie locale.
	const couvertures = useCouvertures({ depId: dep.id > 0 ? dep.id : null })
	const couvert = ligneCouvert(couvertures.data)
	const reste = resteBandeau(restePayer, couvert)
	// Arrivée par la pastille « ✓ Couvert » du dispatch (#couvertures).
	const ancreVue = useRef(false)
	useEffect(() => {
		if (ancreVue.current || !couvertures.data) return
		if (location.hash !== `#${ANCRE_COUVERTURES}`) return
		ancreVue.current = true
		setTimeout(defilerVersCouvertures, 150)
	}, [couvertures.data, location.hash])
	const [showChrono, setShowChrono] = useState(false)
	// Destination inconnue (même mécanique que DepMissionV2) : la fiche se
	// sauve avec destination_finale = null. Resynchronisée au changement de
	// fiche (chargement, pagination) : une destination « jamais saisie » sur
	// une fiche existante ne peut venir que d'une sauvegarde « inconnue ».
	const [destinationInconnue, setDestinationInconnue] = useState(false)
	useEffect(() => {
		setDestinationInconnue(
			dep.id > 0 &&
				!dep.surPlace &&
				estPoJamaisSaisi(dep.destination_finale),
		)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dep.id])
	// Soft-lock des lieux (décision Jordan 12.08.2026) : sur une fiche
	// EXISTANTE, lieu d'intervention et destination sont verrouillés pour tout
	// le monde ; seul le boss peut déverrouiller, par un clic explicite (le
	// cadenas de la carte Trajet libère les deux, refonte 06.10). Le
	// déverrouillage ne vaut que pour la fiche affichée : re-verrouillé au
	// changement de fiche (chargement, feuilletage). Une fiche neuve n'est
	// jamais verrouillée (le lieu DOIT se saisir à la création).
	const [lieuxDeverrouilles, setLieuxDeverrouilles] = useState(false)
	useEffect(() => {
		setLieuxDeverrouilles(false)
	}, [dep.id])
	const lieuxVerrouilles = dep.id !== 0 && !lieuxDeverrouilles
	// Attributs de la bande « Intervenu à » calculés hors JSX (le ternaire
	// chaîné en attribut déclenchait un faux positif rules-of-hooks du plugin).
	const styleBandeChrono = { minWidth: 150 }
	let clickBandeChrono
	let titreBandeChrono
	if (peutVoirChrono) {
		styleBandeChrono.cursor = "pointer"
		clickBandeChrono = () => setShowChrono(true)
		titreBandeChrono = "Chronologie de l'intervention"
	} else if (dep.timestamp_0) {
		titreBandeChrono = `Début ${dep.timestamp_0} · Arrivée ${dep.timestamp_1} · Fin ${dep.timestamp_3 || dep.timestamp_2}`
	}
	// Mémoïsé (revue 02.10, R11) : une nouvelle liste à chaque rendu
	// relançait les effets du modal e-mail (comme AtelierV2 / LocationV2).
	const expertMail = (experts || []).find((e) => e.id === dep.expert)
	const destinatairesMail = useMemo(
		() => destinatairesEmail(dep.email, expertMail),
		[dep.email, expertMail],
	)

	// ─── Refs clavier (chaînes Enter, partagées entre cartes) ───
	const refAppel = useRef(null)
	const refDepanneur = useRef(null)
	const refDepanneuse = useRef(null)
	const refSecteur = useRef(null)
	const refAvecCle = useRef(null)
	const refMat = useRef(null)
	const refChassis = useRef(null)
	const refMarque = useRef(null)
	const refModele = useRef(null)
	const refPlaques = useRef(null)
	const refNom = useRef(null)
	const refAssurance = useRef(null)
	const refNDos = useRef(null)
	const refTarifBase = useRef(null)
	const refHsup = useRef(null)
	const refNote = useRef(null)
	const refs = {
		refAppel,
		refDepanneur,
		refDepanneuse,
		refSecteur,
		refAvecCle,
		refMat,
		refChassis,
		refMarque,
		refModele,
		refPlaques,
		refNom,
		refAssurance,
		refNDos,
		refTarifBase,
		refHsup,
		refNote,
	}

	// ─── État UI (modals) ───
	const [showSaveModal, setShowSaveModal] = useState(false)
	// Jordan 30.10 (lot 7) : modale « Livrer / Restituer » (remplace
	// RestiModal et le bouton « Créer une relivraison »).
	const [showLivrerResti, setShowLivrerResti] = useState(false)
	// GE-46 : renvoi manuel (quittance…) une fois l'e-mail client complété.
	const [showModalEmail, setShowModalEmail] = useState(false)
	const [showAddTransaction, setShowAddTransaction] = useState(false)
	// Repli des cartes, partagé par ligne : replier une carte replie sa ligne
	// entière (les hauteurs restent cohérentes).
	const [openInfo, setOpenInfo] = useState(true) // Client / Véhicule / Intervention
	const [openLieux, setOpenLieux] = useState(true) // Trajet
	const [openSinNotes, setOpenSinNotes] = useState(true) // Sinistres / Diagnostique
	const [openCommentaires, setOpenCommentaires] = useState(true)
	const [openTarifs, setOpenTarifs] = useState(true)
	const [openTransactions, setOpenTransactions] = useState(true)
	const [openCouvertures, setOpenCouvertures] = useState(true)
	const toggle = (setter) => () => setter((o) => !o)
	const [showDepToLocation, setShowDepToLocation] = useState(false)
	// Livraison : modal de création + mission créée dans la session (le
	// serializer fiche fournit livraison_mission aux chargements suivants).
	const [showLivraisonModal, setShowLivraisonModal] = useState(false)
	const [livraisonCreee, setLivraisonCreee] = useState(null)
	const [fileDisplay, setFileDisplay] = useState(null)
	// A5 (CDC 16.10) : restitution avec frais → la quittance attend la
	// sauvegarde (sa transaction n'existe pas encore en base, la quittance
	// sortait sans montant) ; générée sur la transaction enregistrée.
	const quittanceRestiRef = useRef(false)

	// Transactions V2 (chantier « DepTransaction → TransactionV2 ») : liste
	// unique servie par le serializer fiche — saisie fiche ÉDITABLE
	// (dep_mission NULL, synchronisée par le POST api/depannages) +
	// encaissements terrain VERROUILLÉS (dep_mission posé : montant serveur,
	// datation dans /encaissements). Docs normalisés à la volée (idempotent).
	const normDoc = (doc) => (doc && !doc.name ? normalizePdf(doc) : doc)
	const transactionsV2 = (dep.transactionsv2 || []).map((t) => ({
		...t,
		quittance: normDoc(t.quittance),
		facture: normDoc(t.facture),
	}))

	// Re-fetch de la liste (après génération / suppression / upload d'un
	// document) — re-posée dans le dep redux sans marquer la fiche dirty.
	const refreshTransactionsV2 = async () => {
		const res = await fetch(
			`${URL}api/transactionv2?depannage_id=${dep.id}`,
			{ headers: { Authorization: `Bearer ${navLogin.token}` } },
		)
		const json = await res.json()
		fiche.refreshTransactionsV2(Array.isArray(json) ? json : [])
	}

	// Quittance dépannage : générée côté SERVEUR (api/pdf — squelette « PDF
	// en construction » en attendant le rework du contenu ; remplace le PDF
	// client PDF/DepQuittance). transaction_id > 0 (TransactionV2) → document
	// rattaché au slot Quittance + refetch ; 0 (ligne legacy) → simple
	// téléchargement.
	const generateQuittance = async (transactionId = 0) => {
		const response = await fetch(
			`${URL}api/pdf?id=${dep.id}&type=depannage&pdf_type=quittance&transaction_id=${transactionId}`,
			{ headers: { Authorization: `Bearer ${navLogin.token}` } },
		)
		try {
			await downloadPdfFromResponse(response)
		} catch (err) {
			// Refus serveur (AppError) : toast, pas de « document.pdf » vide.
			dispatch(toastApiError(err))
			return
		}
		if (transactionId) await refreshTransactionsV2()
	}

	const deleteTransactionDoc = (transaction_id, doc_to_delete) => {
		fetch(`${URL}api/transactionv2`, {
			method: "DELETE",
			body: JSON.stringify({
				transaction_id,
				doc_to_delete,
				// Revue 7 (Lg8) : la fiche de la ligne.
				depannage_id: dep.id,
			}),
			headers: { Authorization: `Bearer ${navLogin.token}` },
		})
			// QA 12.10 : refus du serveur (ex. 403 « seul un boss ou un admin
			// retire ce document ») affiché en toast, plus avalé.
			.then(handleErrors)
			.then(refreshTransactionsV2)
			.catch(catchApiError(dispatch, null))
	}

	// A4 (Jordan 12.10) : annulation d'un encaissement terrain (boss /
	// admin, motif obligatoire) ; erreur affichée dans le modal. Fiche
	// RECHARGÉE ensuite (ligne supprimée + note de trace — un save d'un
	// état local périmé effacerait la note) : refusée tant qu'elle a des
	// modifications non sauvegardées.
	const annulerEncaissement = async (tx, motif) => {
		if (!canQuit)
			return "Sauvegardez d'abord la fiche (modifications en cours)."
		const res = await fetch(`${URL}api/encaissement_terrain/annuler`, {
			method: "POST",
			body: JSON.stringify({
				transaction_id: tx.id,
				depannage_id: dep.id,
				motif,
			}),
			headers: {
				Authorization: `Bearer ${navLogin.token}`,
				"Content-Type": "application/json",
			},
		})
		const json = await res.json().catch(() => null)
		if (!res.ok) return (json && json.message) || "Annulation impossible."
		await fiche.loadDep(dep.id)
		return null
	}

	// Upload immédiat d'une facture sur une transaction V2 (PUT multipart,
	// comme AtelierV2.uploadTransactionFacture). Revue 27.10 (I1) : refus
	// affiché en toast ; le re-fetch rapatrie la date posée au dépôt.
	const uploadTransactionFacture = (transactionId, file) => {
		const formData = new FormData()
		formData.append("depannage_id", dep.id)
		formData.append(`facture_${transactionId}`, file)
		return fetch(`${URL}api/transactionv2`, {
			method: "PUT",
			body: formData,
			headers: { Authorization: `Bearer ${navLogin.token}` },
		})
			.then(handleErrors)
			.then(refreshTransactionsV2)
			.catch(catchApiError(dispatch, null))
	}

	// ─── Verrou exclusif (partagé avec atelier et location) ───
	// Le 1er à ouvrir la fiche l'édite, les suivants la voient en lecture seule
	// et peuvent demander la main. Le dirty du dépannage étant événementiel,
	// « travail non enregistré » = le quit guard n'autorise pas la sortie.
	const verrou = useFicheVerrou("dep", urlId, {
		// Main obtenue : nos données peuvent être périmées (on était en lecture
		// seule pendant que l'autre session éditait) → rechargement.
		onMainObtenue: () => {
			const ficheId = parseInt(urlId)
			if (Number.isInteger(ficheId) && ficheId > 0) fiche.loadDep(ficheId)
		},
		travailNonEnregistre: !canQuit,
	})
	// Jordan 30.10 : fiche close verrouillée sauf boss (utilities/ficheClose),
	// sur l'état ENREGISTRÉ. `lectureSeule` = tout le corps ; `lectureSeuleBlocs`
	// = Commentaires, E-mail et Sauvegarder (ouverts aux rôles du tableau).
	const verrouClose = verrouFicheClose({
		close:
			dep.id > 0 &&
			depInfo.depCharge?.id === dep.id &&
			depInfo.depCharge.etat === DEPANNAGE_ETAT_CLOS,
		groupes: navLogin.groups,
		module: "depannage",
	})
	const lectureSeuleBlocs = verrou.verrouillee || verrouClose.blocs
	const lectureSeule = verrou.verrouillee || verrouClose.fiche
	// GE-80 : historique de la carte E-mails (slice commun aux 3 fiches).
	const emails = useSelector((state) => state.emailInfo.emails)
	const depIdEmails = Number.isInteger(dep.id) && dep.id > 0 ? dep.id : 0
	useEffect(() => {
		if (depIdEmails > 0)
			dispatch(fetchEmails(depIdEmails, EMAIL_DOMAINE_DEPANNAGE))
	}, [dispatch, depIdEmails])
	const [cloreManquants, setCloreManquants] = useState([])
	// Revue 30.10 (🟡5) : affichés après « Facturer », la fiche EST enregistrée
	// (en attente de paiement) — autre titre que le refus de clôture.
	const [manquantsApresFacturer, setManquantsApresFacturer] = useState(false)
	// Lot 9 : état visé par le bouton d'étape ou le menu « ⋯ » (confirmation
	// dans SaveDepFicheV2, puis save avec cet état) ; null = save simple.
	const [etatVise, setEtatVise] = useState(null)
	const [facturation, setFacturation] = useState(false)
	const manquantsApresFacturation = useRef(null)

	const anyModalOpen =
		showSaveModal ||
		showLivrerResti ||
		showAddTransaction ||
		showDepToLocation ||
		fileDisplay !== null ||
		facturation ||
		cloreManquants.length > 0 ||
		// Revue GE-80 (🟡) : toutes les modales de la fiche (raccourcis
		// clavier) — e-mail, création de livraison, chronologie, chargement
		// de « Louer véhicule ».
		showModalEmail ||
		showLivraisonModal ||
		showChrono ||
		depInfo.fetchDepToLocation.loading ||
		verrou.modalOuvert

	// A8 : ouverte depuis la page Parc → « Retour » y ramène.
	const backPath =
		depInfo.from === "depSearch"
			? "/depannage/rechercher"
			: depInfo.from === "parc"
				? "/parc"
				: "/"

	// Échap : règle unifiée des 3 fiches (31.07.2026) — retour au tableau de
	// résultats s'il en reste en redux, sinon au formulaire de recherche. Ne
	// dépend PLUS de l'origine de la navigation (`backPath`), qui reste la
	// règle du bouton « Retour » et du redirect d'échec de chargement.
	// ⚠ Calculé DANS le handler (et pas ici) : une condition de plus dans le
	// corps du composant fait déborder le compteur de chemins du vieux
	// eslint-plugin-react-hooks et casse le build sur de faux « hook appelé
	// conditionnellement » (cf. section toolchain de tasks.md).
	const escapePath = () =>
		searchDeps.length > 0 || searchLivs.length > 0
			? "/depannage/resultats"
			: "/depannage/rechercher"

	// ─── Feuilletage Page Up / Page Down (liste figée par la page-liste) ───
	// Remplace le pgUpDn historique : plus d'index compté à la main dans le
	// slice (il se désynchronisait dès qu'une navigation ne passait pas par les
	// touches), la position se dérive de l'URL. Suspendu modal ouvert, comme
	// le faisait l'ancien handler.
	useFeuilletage("dep", "/depannage/fiche", anyModalOpen)

	// `from`/`info` arrivent soit en props custom de location (legacy Redirect),
	// soit dans location.state (history.push(path, { from }) des pages V2).
	const navFrom = location.from || (location.state && location.state.from)

	// ─── Chargement (mount + changement d'id : feuilletage PgUp/PgDn) ───
	useEffect(() => {
		const ficheId = parseInt(urlId)
		setFrom(navFrom)
		// État local de la fiche précédente : la mission de livraison créée
		// dans la session ne vaut que pour SA fiche (le composant n'est pas
		// démonté au feuilletage, elle fuyait sur la fiche suivante).
		setLivraisonCreee(null)
		if (Number.isInteger(ficheId) && ficheId > 0) {
			fiche.loadDep(ficheId).then((fresh) => {
				// Chargement impossible : le slice a été vidé (bouton nav
				// regrisé), on ne laisse pas l'utilisateur sur une fiche vide
				// portant l'URL d'une fiche qui n'existe pas.
				if (!fresh) {
					history.replace(backPath)
					return
				}
				window.scrollTo(0, 0)
			})
		} else {
			// B16 (CDC 16.10, AD-DEP-APP-1) : plus de fiche créée au bureau —
			// une fiche naît d'une mission (dispatch / terrain, conversion).
			history.replace("/depannage/dispatch")
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [urlId])

	// Origine de la navigation : ne sert plus qu'au bouton « Retour »
	// (`backPath`). Le feuilletage, lui, ne dépend plus d'un index compté à la
	// main mais de la liste figée par la page-liste (cf. useFeuilletage).
	const setFrom = (from) => {
		let value = null
		switch (from) {
			case "depSearch":
				value = "depSearch"
				break
			case "home":
				value = "home"
				break
			case "parc":
				value = "parc"
				break
			default:
				break
		}
		if (value) dispatch({ type: "SET_DEP_FROM", value })
	}

	// ─── Impression PDF (bouton + F11) — mêmes arguments que le legacy ───
	const printPdf = () =>
		depFiche(
			dep,
			employes,
			depInfo.depVehicules.filter((dv) => dv.type === 0),
			moyenPaiements,
		)

	// ─── Sauvegarde ───
	const checkBeforeSave = () => {
		dispatch(
			postDepannageErrorField(
				checkErrors(dep, mdpFacture, destinationInconnue),
			),
		)
		setShowSaveModal(true)
	}

	// Bouton « Sauvegarder » (SaveDepFicheV2) : appelé avec l'événement du
	// clic — il ne doit JAMAIS servir de `modifs` (lot 7 : sinon l'objet DOM
	// part dans le JSON, structure circulaire, rien n'est enregistré).
	const save = () => enregistrer()

	// → Promise<boolean> (enregistrée). `modifs` : champs posés au moment du
	// save (Facturer : état et transactions datées par le dépôt).
	const enregistrer = (modifs = {}) => {
		const cloned = JSON.parse(JSON.stringify({ ...dep, ...modifs }))
		cloned.marque = cloned.marque.trim()
		cloned.modele = cloned.modele.trim()
		// Destination inconnue : null explicite (le POST la garde NULL), la
		// saisie en cours dans le sélecteur masqué n'est pas envoyée.
		if (destinationInconnue) cloned.destination_finale = null
		// Garde-fou verrou : le back refuse le save (409) si cette session ne
		// détient plus la fiche (prise de main pendant l'édition). Clé hors
		// `concrete_fields` : le setattr générique du POST l'ignore.
		cloned.opener = getOpenerId()
		// A4 : la fiche telle que reçue du serveur — le POST n'écrit que les
		// champs modifiés à l'écran (complément terrain / SvpCentral
		// préservés). Clé hors `concrete_fields`, ignorée par le setattr.
		if (cloned.id > 0 && depInfo.depCharge?.id === cloned.id)
			cloned._charge = depInfo.depCharge
		return dispatch(postDepannage(JSON.stringify(cloned))).then(() => {
			// Le thunk est `silent` (l'erreur s'affiche dans SaveDepFicheV2) et
			// son .catch RÉSOUT : sans ce test, un 500 déclarerait la fiche
			// propre et la navigation suivante partirait sans popup, saisie
			// perdue. La fiche reste sale tant que le POST n'a pas abouti.
			const { saved } = dispatch(
				(_, getState) => getState().depInfo.postDepannage,
			)
			if (!saved) return false
			setClean()
			// GE-60 (revue I2) : la carte Couvertures relit les calculs serveur.
			couvertures.recharger()
			if (quittanceRestiRef.current) {
				quittanceRestiRef.current = false
				const sauvee = dispatch((_, getState) => getState().depInfo.dep)
				const tx = (sauvee.transactionsv2 || [])
					.filter(
						(t) =>
							t.raison === "Restitution" &&
							Number.isInteger(t.id) &&
							!t.quittance,
					)
					.sort((a, b) => b.id - a.id)[0]
				if (tx) generateQuittance(tx.id)
			}
			return true
		})
	}

	// ─── Facturer (Jordan 30.10, état « Ok pour facturation ») ───
	// Modale commune (others/FacturationModalV2) : dépôt des factures des
	// lignes Facture (hors Master), puis Clos si tout est en Facture, que
	// l'utilisateur peut clore ET que la règle de clôture passe — sinon « En
	// attente de paiement » (ce qui manque s'affiche ensuite).
	const lignesAFacturer = () =>
		transactionsV2.filter(
			(t) =>
				Number.isInteger(t.id) &&
				!!mdpFacture &&
				t.moyenPaie === mdpFacture.id &&
				t.payeParSelect !== PAYE_PAR_MASTER,
		)
	const facturerDep = (transactions, toutesFacture) => {
		let etat = DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT
		if (toutesFacture && hasRight("atelier_cloture")) {
			const manquants = manquantsClotureDepannage({
				transactions,
				restePayer,
				isInParc: dep.isInParc,
				estFacture: (t) =>
					!!mdpFacture && t.moyenPaie === mdpFacture.id,
			})
			if (manquants.length > 0)
				manquantsApresFacturation.current = manquants
			else etat = DEPANNAGE_ETAT_CLOS
		}
		return enregistrer({ etat, transactionsv2: transactions }).then(
			(ok) =>
				ok ||
				// Revue 30.10 (F1) : la cause du refus (thunk silencieux).
				(
					dispatch(
						(_, getState) => getState().depInfo.postDepannage.error,
					) || {}
				).message ||
				false,
		)
	}

	const cancelSaveModal = () => {
		setShowSaveModal(false)
		dispatch(postDepannageReset())
	}

	const closeSaveModalAfterSaved = () => {
		setShowSaveModal(false)
		setTimeout(() => dispatch(postDepannageReset()), 500)
	}

	// ─── Louer véhicule (DepToLocation, réutilisé tel quel) ───
	// Location.js lit `id`/`depId`/`redirectLocationInfo` en props custom de
	// ─── Créer une livraison (mission dispatch depuis la fiche) ───
	// Mission livraison liée (créée dans la session ou connue du serializer).
	const livraisonMission = livraisonCreee || dep.livraison_mission
	// Jordan 30.10 (lot 7) : UN bouton — « Livrer / Restituer » si le
	// véhicule est dans un de nos parcs (isInParc, serveur), « Livrer » s'il
	// est ailleurs ; rien à l'atelier SVP (la fiche de réparation gère la
	// suite), après la restitution, sur une fiche annulée ou close (lot 4).
	// Lieu actuel = destination de la dernière livraison, sinon la
	// destination finale (même ordre que le serveur, views ~6855).
	const derniereLivraison = (dep.livraisons || []).slice(-1)[0]
	const lieuActuel = derniereLivraison
		? derniereLivraison.destination_adresse
		: dep.destination_finale
	const aLAtelierSvp =
		!dep.isInParc &&
		(!!(
			lieuActuel &&
			lieuActuel.id &&
			lieuActuel.type === POI_TYPE_ATELIER
		) ||
			(!derniereLivraison && !!dep.svpMeca))
	const boutonLivrerRestituer =
		dep.id > 0 &&
		dep.etat !== DEPANNAGE_ETAT_ANNULE &&
		// Revue des lots 7-8 (🟡3) : restitution faite = sa DATE (une note ou
		// un montant tapés dans Tarifs ne sortent pas le véhicule du parc).
		!dep.restiDate &&
		!aLAtelierSvp &&
		!verrouClose.fiche

	// location (pattern legacy) ; le pathname doit matcher /location/fiche/:id
	// (le legacy poussait « /location/fiche:id » sans slash → route jamais montée).
	// Pas de setClean() ici : « Louer véhicule » quitte la fiche comme
	// n'importe quelle navigation, le quit guard doit pouvoir retenir une
	// saisie non sauvegardée (le setClean legacy le court-circuitait).
	const goLocation = (info, depId, locationId = -1) => {
		history.push({
			pathname: `/location/fiche/${locationId > 0 ? locationId : -1}`,
			id: locationId,
			depId,
			redirectLocationInfo: info,
			from: "ficheDepannage",
		})
	}

	const openDepToLocation = () => {
		const depId = dep.id
		dispatch(fetchDepToLocation({ depId })).then(() => {
			const { clients, vehicules } = dispatch(
				(_, getState) => getState().depInfo.depToLocation,
			)
			if (clients.length === 0 && vehicules.length === 0) {
				goLocation(
					{
						client: {
							id: 0,
							nom: dep.nom,
							prenom: dep.prenom,
							tel: dep.telephone,
						},
					},
					depId,
				)
			} else if (clients.length === 1) {
				goLocation({ client: { id: clients[0].id } }, depId)
			} else {
				setShowDepToLocation(true)
			}
		})
	}

	const dblClickClient = (client) =>
		goLocation({ client: { id: client.id } }, dep.id)

	const dblClickVehicule = (vehicule) => {
		dispatch(fetchDepToLocation({ vehiculeId: vehicule.id })).then(() => {
			const { clients } = dispatch(
				(_, getState) => getState().depInfo.depToLocation,
			)
			if (clients.length === 1)
				goLocation({ client: { id: clients[0].id } }, dep.id)
		})
	}

	// ─── Raccourcis clavier : F4 (boss), F11 (imprimer), F12 (sauvegarder),
	// Échap (retour — le quit guard intercepte si non sauvegardé) ───
	useEffect(() => {
		const keyListener = (e) => {
			// GE-59 (C6) : tiroir / modal d'assistance ouvert par-dessus la
			// fiche — ses touches ne pilotent pas la fiche.
			if (anyModalOpen || document.querySelector("[data-assistance-ui]"))
				return
			switch (e.key) {
				case "F4":
					e.preventDefault()
					if (isBoss && !lectureSeule) fiche.bossTransactionDate()
					break
				case "F11":
					e.preventDefault()
					printPdf()
					break
				case "F12":
					e.preventDefault()
					if (!lectureSeuleBlocs) checkBeforeSave()
					break
				case "Escape":
					// Liste à suggestions ouverte ou fenêtre ouverte : pas de
					// navigation (règle commune des 3 fiches, echapFiche.js).
					if (echapIgnoreParFiche(e)) return
					history.push(escapePath())
					break
				default:
					break
			}
		}
		document.addEventListener("keydown", keyListener)
		return () => document.removeEventListener("keydown", keyListener)
	})

	// Sections auto-ouvertes selon les données (les cartes montent après le
	// chargement, defaultOpen est donc calculé sur la fiche chargée).
	const status = useMemo(
		() => sectionStatus(dep),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[depInfo.fetchDep.loading, dep.id],
	)

	// Le guard reste monté pendant le chargement : sans lui, la fenêtre du
	// fetch (feuilletage, retour de save) laissait passer n'importe quelle
	// navigation sans contrôle.
	if (depInfo.fetchDep.loading)
		return (
			<div style={gs.page} className="dep-fiche-v2">
				<Loader variant="ring" message="Chargement de la fiche…" />
				{QuitGuard}
			</div>
		)

	// Vignette fichier : image cliquable, tuile vidéo ou icône lecture (pdf…).
	// Taille paramétrable : 100×80 (carte Fichiers), 50×40 (carte Trajet).
	const vignetteFichier = (largeur, hauteur) => (file, index) => {
		const petite = largeur < 100
		const marge = petite ? { margin: 3 } : null
		const ext = file.name.split(".").pop().toLowerCase()
		const open = () => setFileDisplay({ file, extra: { saved: true, ext } })
		if (["jpg", "jpeg"].includes(ext)) {
			return (
				<img
					key={`file_${index}`}
					style={{ ...styles.filePreview, ...marge }}
					src={`${URL}${file.url.substring(1)}`}
					alt=""
					width={largeur}
					height={hauteur}
					onClick={open}
					onError={onMediaError}
				/>
			)
		}
		// Vidéo : première frame en vignette (#t=0.1 force le rendu de la frame,
		// preload="metadata" limite le téléchargement — quelques centaines de Ko
		// en prod grâce aux Range requests nginx ; en dev local le serveur Django
		// ne gère pas les Range et peut télécharger la vidéo entière).
		if (VIDEO_EXTS.includes(ext)) {
			return (
				<div
					key={`file_${index}`}
					style={{
						...styles.filePreview,
						...marge,
						position: "relative",
						width: largeur,
						height: hauteur,
						overflow: "hidden",
						border: `1px solid ${COLORS.border}`,
					}}
					onClick={open}
				>
					<video
						src={`${URL}${file.url.substring(1)}#t=0.1`}
						preload="metadata"
						muted
						onError={onMediaError}
						style={{
							width: "100%",
							height: "100%",
							objectFit: "cover",
							pointerEvents: "none",
							display: "block",
						}}
					/>
					<div style={styles.fileVideoOverlay}>
						<FontAwesomeIcon
							icon={faPlay}
							style={{
								color: "#fff",
								fontSize: petite ? 10 : 16,
							}}
						/>
					</div>
					{file.size && !petite && (
						<div style={styles.fileVideoCaption}>{file.size}</div>
					)}
				</div>
			)
		}
		return (
			<div
				key={`file_${index}`}
				style={{
					...styles.filePreview,
					...marge,
					width: largeur,
					height: hauteur,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					border: `1px solid ${COLORS.border}`,
				}}
				onClick={open}
			>
				<FontAwesomeIcon
					icon={faPlay}
					style={{ color: COLORS.accent, fontSize: petite ? 14 : 28 }}
				/>
			</div>
		)
	}
	const filePreview = vignetteFichier(100, 80)
	const vignetteTrajet = vignetteFichier(50, 40)

	// Livraisons en ordre chronologique — prolongent la chaîne Lieu →
	// Destination de la bande de mission (suite logique du véhicule). Le n°
	// affiché reste l'index serveur, pour coller à Tarifs.
	const livraisonsChrono = (dep.livraisons || [])
		.map((liv, index) => ({ liv, numero: index + 1 }))
		.sort((a, b) =>
			(a.liv.datetime || "9999").localeCompare(b.liv.datetime || "9999"),
		)

	// La carte grise (fileType 2) vit dans la carte Véhicule ; les avant /
	// après dans la carte Trajet (la carte Fichiers est supprimée, 08.10).
	// GE-59 (A2) : la carte grise de TOUTES les livraisons aussi (SvpCentral
	// rattache tous les fichiers d'une suite à sa livraison).
	const carteGriseFiles = (dep.files || []).filter((f) => f.fileType === 2)
	// Hoisté hors du JSX (comme showTransactionsCard sur AtelierV2) : les
	// ternaires inline déclenchent le faux positif rules-of-hooks du vieux
	// plugin eslint de CRA 3.
	const carteGriseSlot =
		carteGriseFiles.length > 0 ? (
			<div>
				<div style={styles.fileColTitle}>Carte grise</div>
				<div
					style={{
						...styles.fileRow,
						justifyContent: "flex-start",
					}}
				>
					{carteGriseFiles.map(filePreview)}
				</div>
			</div>
		) : null
	const stripDestination = destinationStrip(dep, destinationInconnue)
	const isNew = dep.id === 0
	const vehiculeLabel = `${dep.marque} ${dep.modele}`.trim()
	const titleLabel =
		[vehiculeLabel, dep.plaques].filter(Boolean).join(" — ") ||
		"Fiche de dépannage"
	// Jordan 30.10 (lot 5) : menu des états depuis l'état ENREGISTRÉ ; Clos
	// = droit « atelier_cloture » (règle de clôture vérifiée avant, comme le
	// serveur) ; sortir de Clos = boss.
	const etatEnregistre =
		dep.id > 0 && depInfo.depCharge?.id === dep.id
			? depInfo.depCharge.etat
			: dep.etat
	// Lot 9 (Jordan 30.10) : bouton d'étape (marche normale) ; le menu « ⋯ »
	// garde les cas exceptionnels. Chacun : contrôles client, confirmation,
	// puis save avec le nouvel état (le serveur garde tous ses contrôles).
	const etape = etapeSuivanteDepannage(etatEnregistre, {
		peutClore: hasRight("atelier_cloture"),
	})
	// Lot 10 (D2, Jordan 30.10) : la restitution n'enchaîne rien — rappel des
	// deux étapes quand le contrôle est l'étape suivante.
	const messageSuiteResti =
		etape && etape.cible === DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION
			? "Restitution saisie : enregistrez puis passez au contrôle"
			: null
	const autresEtats = autresEtatsDepannage(etatEnregistre, {
		isBoss,
		peutClore: hasRight("atelier_cloture"),
		peutFacturer: hasRight("facturer_fiche"),
	})
	// Revue du lot 9 (🟡L9-1) : « au parc » relu sur le SERVEUR (une
	// livraison terminée sur la tablette arrive par la conversion SvpCentral,
	// la fiche ouverte ne le sait pas) ; en cas d'échec, l'état du formulaire.
	const auParcServeur = () =>
		fetch(`${URL}api/depannages?id=${dep.id}`, {
			headers: { Authorization: `Bearer ${navLogin.token}` },
		})
			.then((res) => (res.ok ? res.json() : null))
			.then((json) => {
				const d = Array.isArray(json) ? json[0] : json
				return d ? !!d.isInParc : dep.isInParc
			})
			.catch(() => dep.isInParc)
	const changerEtat = (etat) => {
		// Jordan 30.10 (lots 7 et 9) : « Contrôle avant facturation » refusé
		// tant que le véhicule est au parc → RIEN n'est enregistré : message
		// et modale « Livrer / Restituer » (une livraison seulement créée ne
		// débloque pas : isInParc vient du serveur).
		if (
			etat === DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION &&
			dep.isInParc &&
			boutonLivrerRestituer
		) {
			auParcServeur().then((auParc) => {
				if (!auParc) return demanderEtat(etat)
				dispatch(
					showToast(
						"warning",
						"Véhicule encore au parc : restituer d'abord. Une livraison terminée sur la tablette est prise en compte en quelques minutes.",
					),
				)
				setShowLivrerResti(true)
			})
			return
		}
		demanderEtat(etat)
	}
	const demanderEtat = (etat) => {
		if (
			etat === DEPANNAGE_ETAT_CLOS &&
			etatEnregistre !== DEPANNAGE_ETAT_CLOS
		) {
			const manquants = manquantsClotureDepannage({
				transactions: dep.transactionsv2,
				restePayer,
				isInParc: dep.isInParc,
				estFacture: (t) =>
					!!mdpFacture && t.moyenPaie === mdpFacture.id,
			})
			if (manquants.length > 0) return setCloreManquants(manquants)
		}
		dispatch(
			postDepannageErrorField(
				checkErrors(dep, mdpFacture, destinationInconnue),
			),
		)
		setEtatVise(etat)
		setShowSaveModal(true)
	}
	const etatBadge =
		DEPANNAGE_ETAT_BADGE[dep.etat] ??
		DEPANNAGE_ETAT_BADGE[DEPANNAGE_ETAT_EN_COURS]

	return (
		<div style={gs.page} className="dep-fiche-v2">
			<div style={styles.content}>
				{/* ===== Header ===== */}
				<div style={{ ...gs.header, alignItems: "center", gap: 16 }}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 16,
							minWidth: 0,
						}}
					>
						<button
							style={styles.back}
							onClick={() => history.push(backPath)}
							title="Retour"
						>
							<FontAwesomeIcon icon={faArrowLeft} />
						</button>
						<div style={{ minWidth: 0 }}>
							<div style={styles.kicker}>
								{isNew
									? "Dépannage"
									: `Dépannage — Fiche n° ${dep.id}`}
							</div>
							<div style={styles.title}>{titleLabel}</div>
							{verrou.verrouillee && (
								<BoutonDemanderMain
									detenuePar={verrou.detenuePar}
									onClick={verrou.demanderLaMain}
								/>
							)}
						</div>
					</div>
					<div
						style={{
							display: "flex",
							gap: 10,
							alignItems: "center",
						}}
					>
						{/* Jordan 30.10 (lot 5) : menu des états (others/MenuEtatFicheV2),
						    pilule simple sans choix. */}
						{!isNew && (
							<MenuEtatFicheV2
								valeur={dep.etat}
								libelles={DEPANNAGE_ETAT_DICT}
								couleur={etatBadge}
								disabled={lectureSeule}
								onChange={changerEtat}
								autres={autresEtats}
								libelleAutre={(e) =>
									libelleAutreEtat(
										etatEnregistre,
										e,
										DEPANNAGE_ETAT_DICT,
									)
								}
							/>
						)}
						{/* GE-47 : mission créée sur le terrain (piquet). */}
						{dep.mission_terrain && (
							<span
								style={{
									...gs.badge(
										COLORS.accent,
										COLORS.accentLight,
									),
									...gs.entete,
								}}
								title="Mission créée sur le terrain (dispatch de piquet)"
							>
								{dep.mission_terrain.cree_par_nom
									? `Terrain · créée par ${dep.mission_terrain.cree_par_nom}`
									: "Terrain"}
							</span>
						)}
						{dep.appel_type === DEPANNAGE_TYPE_APPEL_POLICE && (
							<span
								style={{
									...gs.badge(
										COLORS.accent,
										COLORS.accentLight,
									),
									...gs.entete,
								}}
								title="Appel police : clé, accident ou enlèvement, lieu d'intervention et catégorie du véhicule requis (matricule différable)"
							>
								Police
							</span>
						)}
						<button
							type="button"
							style={{
								...styles.chip(
									dep.marked,
									COLORS.gold,
									COLORS.warningLight,
								),
								...gs.entete,
							}}
							onClick={(e) =>
								fiche.updateDep("marked", e, "checkbox")
							}
							title="Marquer la fiche pour la retrouver facilement"
							disabled={lectureSeule}
						>
							<FontAwesomeIcon icon={faStar} />
							{dep.marked ? "Marquée" : "Marquer"}
						</button>
						{/* GE-67 / Fc6 (Jordan 12.10) : fiche atelier liée et
						    fiches des fournitures du dépanneur (une par
						    mission), chacune repérable par son n°. */}
						{!isNew &&
							Number.isInteger(dep.id) &&
							boutonsFichesAtelier(dep).map((b) => (
								<button
									key={`atelier_${b.id}`}
									style={
										marqueurFicheLiee(
											dep.soldes_liees,
											"atelier",
											b.id,
										).style
									}
									onClick={() =>
										history.push(`/atelier/fiche/${b.id}`)
									}
									title={
										b.title +
										marqueurFicheLiee(
											dep.soldes_liees,
											"atelier",
											b.id,
										).titre
									}
								>
									<FontAwesomeIcon
										icon={
											b.fournitures ? faBoxOpen : faTools
										}
									/>
								</button>
							))}
						{dep.location > 0 &&
							!isNew &&
							Number.isInteger(dep.id) && (
								<button
									style={
										marqueurFicheLiee(
											dep.soldes_liees,
											"location",
											dep.location,
										).style
									}
									onClick={() =>
										goLocation({}, -1, dep.location)
									}
									title={
										`Location N° ${dep.location}` +
										marqueurFicheLiee(
											dep.soldes_liees,
											"location",
											dep.location,
										).titre
									}
								>
									<FontAwesomeIcon icon={faCar} />
								</button>
							)}
						{isBoss && (
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: 8,
									marginLeft: 4,
								}}
							>
								<FontAwesomeIcon
									icon={faCrown}
									title="Boss"
									style={{
										fontSize: 14,
										color: dep.boss
											? COLORS.gold
											: COLORS.textLight,
										transition: "color 0.15s",
									}}
								/>
								<Switch
									on={dep.boss}
									title="Boss"
									disabled={lectureSeule}
									onClick={() =>
										fiche.updateDepField("boss", !dep.boss)
									}
								/>
							</div>
						)}
					</div>
				</div>

				{verrou.verrouillee && (
					<BandeauLectureSeule detenuePar={verrou.detenuePar} />
				)}
				{!verrou.verrouillee && verrouClose.fiche && (
					<BandeauFicheClose
						blocsOuverts={
							verrouClose.blocs ? null : "Commentaires et e-mails"
						}
					/>
				)}
				{!isNew && (
					<BandeauFicheIncomplete champs={dep.champs_manquants} />
				)}

				{/* Lecture seule : tout le corps de la fiche est neutralisé d'un
				    coup par le fieldset (cf. styles.fieldset). Le header (retour,
				    badges) et le footer (Imprimer) restent hors périmètre. */}
				<fieldset disabled={lectureSeule} style={styles.fieldset}>
					{/* ===== Bande de mission : quand, d'où, vers où ===== */}
					<div
						style={{
							...gs.card,
							display: "flex",
							alignItems: "center",
							gap: 24,
							padding: "14px 24px",
							marginBottom: 16,
							flexWrap: "wrap",
						}}
					>
						<div
							style={styleBandeChrono}
							onClick={clickBandeChrono}
							title={titreBandeChrono}
						>
							<div style={styles.micro}>Intervenu à</div>
							<div style={styles.stripValue}>
								{dep.timestamp_1 ||
									`${dep.date} ${dep.heure}`.trim() ||
									"—"}
							</div>
						</div>
						<div
							style={{
								width: 1,
								alignSelf: "stretch",
								backgroundColor: COLORS.border,
							}}
						/>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: 18,
								minWidth: 0,
								flexWrap: "wrap",
							}}
						>
							<div style={{ minWidth: 0, maxWidth: 320 }}>
								<div style={styles.micro}>Lieu</div>
								<div
									style={styles.stripValue}
									title={poiTooltip(dep.lieu_intervention)}
								>
									{poiText(dep.lieu_intervention)}
								</div>
							</div>
							<FontAwesomeIcon
								icon={faLongArrowAltRight}
								style={{
									color: COLORS.accent,
									fontSize: 20,
									flexShrink: 0,
								}}
							/>
							<div style={{ minWidth: 0, maxWidth: 320 }}>
								<div style={styles.micro}>Destination</div>
								<div
									style={styles.stripValue}
									title={stripDestination.title}
								>
									{stripDestination.valeur}
								</div>
							</div>
							{/* Livraisons (chronologiques) : la suite du trajet du
							    véhicule, flèches atténuées pour distinguer la
							    course initiale des livraisons. */}
							{livraisonsChrono.map(({ liv, numero }) => (
								<React.Fragment key={`liv_bande_${liv.id}`}>
									<FontAwesomeIcon
										icon={faLongArrowAltRight}
										style={{
											color: COLORS.textLight,
											fontSize: 20,
											flexShrink: 0,
										}}
									/>
									<div style={{ minWidth: 0, maxWidth: 320 }}>
										<div style={styles.micro}>
											<FontAwesomeIcon
												icon={faTruck}
												style={{ marginRight: 5 }}
											/>
											{[
												`Livraison ${numero}`,
												[liv.date, liv.heure]
													.filter(Boolean)
													.join(" "),
											]
												.filter(Boolean)
												.join(" — ")}
										</div>
										<div
											style={styles.stripValue}
											title={poiTooltip(
												liv.destination_adresse,
											)}
										>
											{poiText(liv.destination_adresse)}
										</div>
									</div>
								</React.Fragment>
							))}
						</div>
					</div>

					{/* ===== Métriques : l'argent de la course en un coup d'œil ===== */}
					<div
						style={{
							display: "grid",
							gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
							gap: 12,
							marginBottom: 16,
						}}
					>
						<div style={gs.statCard}>
							<div style={gs.statLabel}>Tarif de base</div>
							<div style={gs.statValue}>
								{dep.baseTot === "" ? "—" : dep.baseTot}
								<span
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: COLORS.textMuted,
									}}
								>
									{" "}
									CHF
								</span>
							</div>
							<div style={gs.statSub}>Prise en charge</div>
						</div>
						<div style={gs.statCard}>
							<div style={gs.statLabel}>Suppléments</div>
							<div style={gs.statValue}>
								{round2(
									(parseFloat(dep.totalFinal) || 0) -
										(parseFloat(dep.baseTot) || 0),
								)}
								<span
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: COLORS.textMuted,
									}}
								>
									{" "}
									CHF
								</span>
							</div>
							<div style={gs.statSub}>
								Heures supp. · gardiennage · autres
							</div>
						</div>
						<div style={gs.totalHighlight}>
							<div
								style={{ ...gs.statLabel, color: "#ffffff80" }}
							>
								Total final
							</div>
							<div style={{ ...gs.statValue, color: "#fff" }}>
								{dep.totalFinal}
								<span
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: "#ffffff80",
									}}
								>
									{" "}
									CHF
								</span>
							</div>
							<div style={{ fontSize: 11, color: "#ffffff60" }}>
								{dep.tva ? `TVA ${dep.tva}% incluse` : ""}
							</div>
						</div>
						<div style={gs.statCard}>
							<div style={gs.statLabel}>Reste à payer</div>
							<div
								style={{
									...gs.statValue,
									color: reste.couleur,
								}}
							>
								{reste.valeur}
								<span
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: COLORS.textMuted,
									}}
								>
									{" "}
									CHF
								</span>
							</div>
							{couvert ? (
								<button
									type="button"
									style={styles.ligneCouvert}
									onClick={defilerVersCouvertures}
									title="Voir les couvertures"
								>
									{couvert.texte}
								</button>
							) : (
								<div style={gs.statSub}>
									{restePayer > 0
										? `${transactionsV2.length} transaction${transactionsV2.length > 1 ? "s" : ""} saisie${transactionsV2.length > 1 ? "s" : ""}`
										: "Payé"}
								</div>
							)}
						</div>
					</div>

					{/* ===== Client / Véhicule / Intervention (3 cartes égales) ===== */}
					{/* alignItems stretch → les 3 cartes prennent la hauteur de la plus haute. */}
					<div style={{ ...gs.grid3, alignItems: "stretch" }}>
						<DepFicheClientV2
							dep={dep}
							updateDep={fiche.updateDep}
							refs={refs}
							open={openInfo}
							onToggle={toggle(setOpenInfo)}
						/>
						<DepFicheVehiculeV2
							dep={dep}
							marques={fiche.marques}
							fetchMarquesState={fiche.fetchMarquesState}
							modeles={fiche.modeles}
							fetchModelesState={fiche.fetchModelesState}
							updateDep={fiche.updateDep}
							refs={refs}
							open={openInfo}
							onToggle={toggle(setOpenInfo)}
							carteGriseSlot={carteGriseSlot}
						/>
						<DepFicheInterventionV2
							dep={dep}
							depInfo={depInfo}
							employes={employes}
							fetchEmployesState={fiche.fetchEmployesState}
							assistances={fiche.assistances}
							secteursPolice={fiche.secteursPolice}
							updateDep={fiche.updateDep}
							updateDepField={fiche.updateDepField}
							setAssistance={fiche.setAssistance}
							refs={refs}
							open={openInfo}
							onToggle={toggle(setOpenInfo)}
						/>
					</div>

					{/* ===== GE-60 : couvertures d'assistance (3 types d'appel, même
					    vide) — remplace le bloc « Assistance » GE-57 et en
					    reprend les ordres. Fiche sauvée seulement. ===== */}
					{dep.id > 0 && (
						<CouverturesCarte
							depId={dep.id}
							etat={couvertures}
							sousTitre={[
								`Fiche ${dep.id}`,
								dep.appel_type === DEPANNAGE_TYPE_APPEL_POLICE
									? "Police"
									: null,
								dep.plaques,
							]
								.filter(Boolean)
								.join(" · ")}
							lectureSeule={lectureSeule}
							open={openCouvertures}
							onToggle={toggle(setOpenCouvertures)}
							onEncaisse={(res) =>
								res &&
								res.transactions &&
								fiche.refreshTransactionsV2(res.transactions)
							}
						/>
					)}

					{/* ===== Trajet : lieu d'intervention → destination ===== */}
					<DepFicheTrajetV2
						dep={dep}
						verrouille={lieuxVerrouilles}
						isBoss={isBoss}
						onDeverrouiller={() => setLieuxDeverrouilles(true)}
						onVerrouiller={() => setLieuxDeverrouilles(false)}
						destinationInconnue={destinationInconnue}
						onInconnu={(v) => {
							setDestinationInconnue(v)
							setDirty()
						}}
						setLieuIntervention={fiche.setLieuIntervention}
						setDestinationFinale={fiche.setDestinationFinale}
						secteursPolice={fiche.secteursPolice}
						rendreFichier={vignetteTrajet}
						open={openLieux}
						onToggle={toggle(setOpenLieux)}
					/>

					{dep.decharge && dep.decharge.saved && (
						<CollapsibleCardV2 title="Documents" defaultOpen>
							<a
								href={`${URL}${dep.decharge.url.substring(1)}`}
								target="_blank"
								rel="noopener noreferrer"
								style={{
									display: "inline-flex",
									alignItems: "center",
									gap: 8,
									color: COLORS.accent,
									textDecoration: "none",
									fontSize: 14,
								}}
							>
								<FontAwesomeIcon icon={faFileAlt} />
								Décharge signée
							</a>
						</CollapsibleCardV2>
					)}
				</fieldset>
				{/* ===== Sinistres | Diagnostique | E-mails ===== GE-80
				    (Jordan 30.10) : la carte E-mails remplace le bouton du pied
				    de fiche ; hors du fieldset de lecture seule (fiche close :
				    rôles du tableau, comme les commentaires — lot 4). */}
				{/* Fiche en création : pas de carte E-mails → 2 colonnes. */}
				<div
					style={{
						...(dep.id > 0 ? gs.grid3 : gs.grid2),
						alignItems: "stretch",
					}}
				>
					<fieldset
						disabled={lectureSeule}
						style={styles.fieldsetCarte}
					>
						<DepFicheSinistresV2
							dep={dep}
							status={status}
							updateDep={fiche.updateDep}
							updateDepField={fiche.updateDepField}
							experts={experts}
							open={openSinNotes}
							onToggle={toggle(setOpenSinNotes)}
						/>
					</fieldset>
					<fieldset
						disabled={lectureSeule}
						style={styles.fieldsetCarte}
					>
						<CollapsibleCardV2
							title="Diagnostique"
							open={openSinNotes}
							onToggle={toggle(setOpenSinNotes)}
						>
							{(() => {
								const info = dep.diagnostique_info
								const isPolice =
									dep.appel_type ===
									DEPANNAGE_TYPE_APPEL_POLICE
								const nom =
									info?.diagnostique_final ||
									info?.diagnostique_presume ||
									(isPolice
										? DIAGNOSTIQUE_POLICE_LABELS[
												info?.diagnostique_police
											] || ""
										: "")
								const MOMENTS = {
									J: "Jour",
									N: "Nuit / férié",
									JOUR: "par jour",
								}
								// GE-66 : lignes du tarif privé (même forme), à défaut.
								const pl =
									dep.police_lignes &&
									dep.police_lignes.length
										? dep.police_lignes
										: dep.prive_lignes || []
								const lignesAgregats =
									isPolice && pl.length === 0
										? [
												{
													label: "Prise en charge",
													montant: dep.baseTot,
												},
												{
													label: "Heures supp.",
													montant: dep.hSupTot,
												},
												{
													label: "Gardiennage",
													montant: dep.gardTot,
												},
											].filter(
												(l) =>
													parseFloat(
														l.montant || 0,
													) !== 0,
											)
										: []
								return (
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											gap: 10,
											padding: "4px 0",
										}}
									>
										{nom ? (
											<div
												style={{
													fontSize: 14,
													fontWeight: 600,
													color: COLORS.text,
												}}
											>
												{nom}
											</div>
										) : (
											<div
												style={{
													fontSize: 13,
													color: COLORS.textMuted,
												}}
											>
												Aucun diagnostic
											</div>
										)}
										{pl.map((l, i) => (
											<div
												key={`pl_${i}`}
												style={{
													padding: "6px 10px",
													backgroundColor: COLORS.bg,
													borderRadius: 8,
													border: `1px solid ${COLORS.border}`,
													fontSize: 13,
												}}
											>
												<div
													style={{
														display: "flex",
														justifyContent:
															"space-between",
														alignItems: "baseline",
													}}
												>
													<span
														style={{
															color: COLORS.text,
														}}
													>
														<strong>
															{l.code}
														</strong>{" "}
														{l.libelle}
													</span>
													<span
														style={{
															fontWeight: 600,
															color: COLORS.text,
															whiteSpace:
																"nowrap",
															marginLeft: 8,
														}}
													>
														{l.total} CHF
													</span>
												</div>
												<div
													style={{
														fontSize: 12,
														color: COLORS.textLight,
														marginTop: 2,
													}}
												>
													{[
														MOMENTS[l.moment] ||
															l.moment,
														l.zone === "autoroute"
															? "Autoroute"
															: null,
														VEHICULE_CATEGORIE[
															l.categorie
														] || null,
														l.quantite > 1
															? `${l.quantite} × ${l.prix_unitaire}`
															: null,
													]
														.filter(Boolean)
														.join(" · ")}
												</div>
											</div>
										))}
										{pl.length > 0 && (
											<div
												style={{
													display: "flex",
													justifyContent: "flex-end",
													fontSize: 14,
													fontWeight: 700,
													color: COLORS.text,
													paddingTop: 2,
												}}
											>
												Total{" "}
												{pl
													.reduce(
														(s, l) => s + l.total,
														0,
													)
													.toFixed(2)}{" "}
												CHF
											</div>
										)}
										{/* GE-75 : annoncé à la création vs facturé. */}
										{pl.length > 0 &&
											!dep.police_lignes.length &&
											ligneAnnonce(
												dep.prive_annonce,
												pl.reduce(
													(s, l) => s + l.total,
													0,
												),
											)}
										{lignesAgregats.map((l) => (
											<div
												key={l.label}
												style={{
													display: "flex",
													justifyContent:
														"space-between",
													alignItems: "center",
													padding: "6px 10px",
													backgroundColor: COLORS.bg,
													borderRadius: 8,
													border: `1px solid ${COLORS.border}`,
													fontSize: 13,
												}}
											>
												<span
													style={{
														color: COLORS.text,
													}}
												>
													{l.label}
												</span>
												<span
													style={{
														fontWeight: 600,
														color: COLORS.text,
													}}
												>
													{l.montant} CHF
												</span>
											</div>
										))}
									</div>
								)
							})()}
						</CollapsibleCardV2>
					</fieldset>
					{dep.id > 0 && (
						<CollapsibleCardV2
							title="E-mails"
							open={openSinNotes}
							onToggle={toggle(setOpenSinNotes)}
						>
							<EmailListV2 emails={emails} />
							{!verrouClose.blocs && (
								<button
									type="button"
									style={gs.btnSecondary}
									onClick={() => setShowModalEmail(true)}
									disabled={lectureSeuleBlocs}
								>
									Nouvel e-mail
								</button>
							)}
						</CollapsibleCardV2>
					)}
				</div>
				<fieldset disabled={lectureSeule} style={styles.fieldset}>
					{/* ===== Tarifs ===== */}
					<DepFicheTarifsV2
						dep={dep}
						updateDep={fiche.updateDep}
						onFocusLost={fiche.onFocusLost}
						gardButton={fiche.gardButton}
						addAutre={fiche.addAutre}
						updateAutre={fiche.updateAutre}
						removeAutre={fiche.removeAutre}
						onRestituer={() => setShowLivrerResti(true)}
						refs={refs}
						open={openTarifs}
						onToggle={toggle(setOpenTarifs)}
					/>
				</fieldset>
				{/* ===== Commentaires (pleine largeur, sous Tarifs) ===== */}
				{/* Jordan 30.10 : bloc ouvert sur une fiche close pour les
					    rôles du tableau (fieldset à part). */}
				<fieldset disabled={lectureSeuleBlocs} style={styles.fieldset}>
					<CollapsibleCardV2
						title="Commentaires"
						open={openCommentaires}
						onToggle={toggle(setOpenCommentaires)}
					>
						{[
							{ title: "Commentaire client", print: true },
							{ title: "Notes internes", print: false },
						].map((section) => {
							const notes = dep.notes.filter(
								(n) => !!n.print === section.print,
							)
							return (
								<div
									key={`sec_${section.print}`}
									style={gs.mt18}
								>
									<div
										style={{
											fontSize: 12,
											fontWeight: 600,
											color: COLORS.text,
											marginBottom: 8,
										}}
									>
										{section.title}
									</div>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											gap: 8,
										}}
									>
										{notes.map((note) => {
											const index = dep.notes.findIndex(
												(n) => n.id === note.id,
											)
											return (
												<div
													key={`note${note.id}`}
													style={{
														...gs.obsItem,
														alignItems:
															"flex-start",
													}}
												>
													<textarea
														rows={2}
														style={{
															...gs.obsInput,
															resize: "vertical",
															minHeight: 38,
														}}
														value={note.text}
														placeholder={
															section.print
																? "Commentaire client…"
																: "Note interne…"
														}
														onChange={(e) =>
															fiche.updateNote(
																"text",
																e,
																index,
															)
														}
													/>
													<button
														type="button"
														style={gs.iconBtn(
															COLORS.danger,
														)}
														onClick={() =>
															fiche.removeNote(
																note,
															)
														}
														title="Supprimer"
													>
														<FontAwesomeIcon
															icon={faTrash}
														/>
													</button>
												</div>
											)
										})}
										<button
											type="button"
											style={{
												...gs.addBtn,
												marginTop: 2,
											}}
											onClick={() =>
												fiche.addNote(section.print)
											}
										>
											<FontAwesomeIcon icon={faPlus} />{" "}
											{section.print
												? "Ajouter un commentaire"
												: "Ajouter une note"}
										</button>
									</div>
								</div>
							)
						})}
					</CollapsibleCardV2>
				</fieldset>
				<fieldset disabled={lectureSeule} style={styles.fieldset}>
					{/* ===== Transactions (pleine largeur) ===== */}
					{/* Carte partagée avec atelier/location. Les encaissements
					    terrain (dep_mission) sont ÉDITABLES comme les autres
					    (décision Jordan 11.08 — fin du verrou par transaction) ;
					    seule la fiche close verrouille tout. */}
					<TransactionsCardV2
						transactions={transactionsV2}
						restePayer={restePayer}
						// Jordan 19.10 : fiche close verrouillée, sauf boss.
						locked={
							dep.etat === DEPANNAGE_ETAT_CLOS && niveau !== BOSS
						}
						onAdd={() => setShowAddTransaction(true)}
						onChange={(idx, key, value) =>
							fiche.updateTransactionV2(idx, key, value)
						}
						onDelete={(idx) => fiche.removeTransactionV2(idx)}
						// Revue 8 (A3) : même règle que le serveur (409) sur la
						// ligne ENREGISTRÉE — datée, facturée, quittancée,
						// WinBIZ, rapprochée ; le boss supprime tout.
						nonSupprimable={(tx) =>
							causeNonSupprimable(tx, { niveau })
						}
						onDeleteDocument={deleteTransactionDoc}
						onAnnulerEncaissement={
							niveau !== EMPLOYE ? annulerEncaissement : null
						}
						// Jordan 15.10 : règle de datation commune, caissier
						// figé dès la ligne enregistrée, annulation terrain.
						datation={(tx) =>
							regleDatation(tx, {
								droitEncaissements:
									hasRight("dater_transactions"),
								niveau,
								mdpFactureId: mdpFacture ? mdpFacture.id : 0,
							})
						}
						champs={(tx) => champsModifiables(tx, { niveau })}
						refusAnnulation={(tx) =>
							refusAnnulationTerrain(tx, { niveau })
						}
						onGenerate={generateQuittance}
						onUploadFacture={uploadTransactionFacture}
						open={openTransactions}
						onToggle={toggle(setOpenTransactions)}
						module="dep"
					/>
				</fieldset>
				{/* Notes système (Jordan 19.10) : boss seulement, hors du
				    fieldset de lecture seule (dépliable fiche verrouillée). */}
				<HistoriqueCardV2
					domaine="depannage"
					objetId={dep.id}
					rafraichir={depInfo.depCharge}
				/>

				{/* ===== Footer ===== (fixé au viewport, aligné au bord du contenu) */}
				<div style={gs.fixedFooter}>
					{livraisonMission ? (
						<span
							style={styles.livraisonChip}
							title={
								livraisonMission.suite
									? "Relivraison créée à la conversion (véhicule déposé au dépôt)"
									: "Relivraison créée depuis la fiche"
							}
						>
							<FontAwesomeIcon icon={faTruck} />
							{`Relivraison : ${
								livraisonMission.etat_label ||
								DEP_STATES[livraisonMission.etat] ||
								""
							}`}
						</span>
					) : null}
					{boutonLivrerRestituer && (
						<button
							style={gs.btnSecondary}
							onClick={() =>
								dep.isInParc
									? setShowLivrerResti(true)
									: setShowLivraisonModal(true)
							}
							// GE-66 passe 5 (🟡4) : la livraison se décide sur la
							// fiche ENREGISTRÉE → saisie en cours à enregistrer.
							disabled={
								lectureSeule || (!dep.isInParc && !canQuit)
							}
							title={
								!dep.isInParc && !canQuit
									? "Enregistrer la fiche avant de créer la livraison"
									: undefined
							}
						>
							{dep.isInParc ? "Livrer / Restituer" : "Livrer"}
						</button>
					)}
					{dep.id > 0 && dep.location === 0 && !verrouClose.fiche && (
						<button
							style={gs.btnSecondary}
							onClick={openDepToLocation}
							disabled={lectureSeule}
						>
							Louer véhicule
						</button>
					)}
					{/* Imprimer reste actif en lecture seule : consulter n'est pas
					    modifier. Les actions qui écrivent, elles, sont neutralisées. */}
					<button style={gs.btnSecondary} onClick={printPdf}>
						Imprimer
					</button>
					{/* Lot 9 : bouton d'étape (Passer au contrôle, Valider le
					    contrôle, Clore) selon l'état ENREGISTRÉ. */}
					{dep.id > 0 && etape && !verrouClose.fiche && (
						<button
							style={gs.btnSecondary}
							onClick={() => changerEtat(etape.cible)}
							disabled={lectureSeule || !etape.autorise}
							title={etape.titre}
						>
							{etape.libelle}
						</button>
					)}
					{/* Jordan 30.10 : « Facturer » (boss, admin, assistant_admin). */}
					{dep.id > 0 &&
						etatEnregistre === DEPANNAGE_ETAT_OK_POUR_FACTURATION &&
						!verrouClose.fiche && (
							<button
								style={gs.btnSecondary}
								onClick={() => setFacturation(true)}
								disabled={
									lectureSeule || !hasRight("facturer_fiche")
								}
								title={
									hasRight("facturer_fiche")
										? undefined
										: "Facturer : boss, admin ou assistant(e) admin"
								}
							>
								{lignesAFacturer().length > 0
									? "Facturer"
									: "En attente de paiement"}
							</button>
						)}
					{!verrouClose.blocs && (
						<button
							style={gs.btnPrimary}
							onClick={checkBeforeSave}
							disabled={lectureSeuleBlocs}
						>
							Sauvegarder
						</button>
					)}
				</div>

				{/* ===== Modals ===== */}
				{facturation && (
					<FacturationModalV2
						aFacturer={lignesAFacturer()}
						lignesNonEnregistrees={compterNonEnregistrees(
							dep.transactionsv2,
							depInfo.depCharge?.id === dep.id
								? depInfo.depCharge.transactionsv2
								: [],
						)}
						champFiche={{ depannage_id: dep.id }}
						onFactures={facturerDep}
						onPasserEnAttente={() => {
							setFacturation(false)
							enregistrer({
								etat: DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT,
							})
						}}
						onClose={() => {
							setFacturation(false)
							if (manquantsApresFacturation.current) {
								setManquantsApresFacturer(true)
								setCloreManquants(
									manquantsApresFacturation.current,
								)
								manquantsApresFacturation.current = null
							}
						}}
					/>
				)}
				{cloreManquants.length > 0 && (
					<CustomModal
						title={
							manquantsApresFacturer
								? "Fiche en attente de paiement : pour clore, il manque"
								: "Clôture impossible : informations manquantes"
						}
						onClose={() => {
							setCloreManquants([])
							setManquantsApresFacturer(false)
						}}
						buttons={[
							{
								title: "Compris",
								styleName: "primary",
								onClick: () => {
									setCloreManquants([])
									setManquantsApresFacturer(false)
								},
							},
						]}
					>
						<p
							style={{
								margin: 0,
								fontSize: 13,
								color: COLORS.textMuted,
							}}
						>
							Avant de clore la fiche, merci de renseigner :
						</p>
						<ul
							style={{
								margin: "8px 0 0",
								paddingLeft: 18,
								fontSize: 13,
								color: COLORS.textMuted,
							}}
						>
							{cloreManquants.map((m, i) => (
								<li key={i}>{m}</li>
							))}
						</ul>
					</CustomModal>
				)}
				{showLivraisonModal && (
					<DepLivraisonMissionModal
						dep={dep}
						onClose={() => setShowLivraisonModal(false)}
						onCreated={(mission) => {
							setLivraisonCreee(mission)
							setShowLivraisonModal(false)
							dispatch(
								showToast(
									"success",
									"Relivraison créée — mission au dispatch",
								),
							)
						}}
					/>
				)}
				{showModalEmail && (
					<EmailModalV2
						onClose={() => setShowModalEmail(false)}
						ficheId={dep.id}
						domaine={EMAIL_DOMAINE_DEPANNAGE}
						destinataires={destinatairesMail}
						ficheModifiee={!canQuit}
					/>
				)}
				{showSaveModal && (
					<SaveDepFicheV2
						post={depInfo.postDepannage}
						avertissements={checkAvertissements(dep)}
						documents={consequencesSaveDep(dep, depInfo.depCharge)}
						titre={
							etatVise === null
								? undefined
								: `Passer la fiche en « ${DEPANNAGE_ETAT_DICT[etatVise]} » ?`
						}
						question={
							etatVise === null
								? undefined
								: canQuit
									? "La fiche est enregistrée avec ce nouvel état."
									: "La fiche est enregistrée avec ce nouvel état, modifications en cours comprises."
						}
						save={
							etatVise === null
								? save
								: () => enregistrer({ etat: etatVise })
						}
						onDone={() => {
							setEtatVise(null)
							closeSaveModalAfterSaved()
						}}
						onCancel={() => {
							setEtatVise(null)
							cancelSaveModal()
						}}
					/>
				)}
				{showLivrerResti && (
					<DepLivrerRestituerModalV2
						dep={dep}
						restePayer={restePayer}
						employes={employes}
						moyenPaiements={moyenPaiements}
						configFrais={configHorsHeures(masterEntite)}
						employeId={navLogin.employeId}
						peutLivrer={canQuit}
						messageSuite={messageSuiteResti}
						onRestituer={(choix) => {
							// Quittance de restitution : générée après la
							// sauvegarde, sur la transaction enregistrée (A5).
							if (fiche.restituer(choix))
								quittanceRestiRef.current = true
							setShowLivrerResti(false)
							if (messageSuiteResti)
								dispatch(
									showToast("success", messageSuiteResti),
								)
						}}
						onLivrer={() => {
							setShowLivrerResti(false)
							setShowLivraisonModal(true)
						}}
						onClose={() => setShowLivrerResti(false)}
					/>
				)}
				{showAddTransaction && (
					<AddDepTransactionModalV2
						onClose={() => setShowAddTransaction(false)}
						addTransaction={fiche.addTransactionV2}
					/>
				)}
				{showChrono && (
					<ChronoModal
						dep={dep}
						employes={employes}
						onClose={() => setShowChrono(false)}
					/>
				)}
				{showDepToLocation && (
					<DepToLocation
						visible={showDepToLocation}
						closeModal={() => setShowDepToLocation(false)}
						depToLocation={depInfo.depToLocation}
						fetchDepToLocation={depInfo.fetchDepToLocation}
						dblClickClient={dblClickClient}
						dblClickVehicule={dblClickVehicule}
					/>
				)}
				{fileDisplay !== null && (
					<FileDisplayer
						visible={fileDisplay !== null}
						closeModal={() => setFileDisplay(null)}
						file={fileDisplay.file}
						extra={fileDisplay.extra}
					/>
				)}
				{depInfo.fetchDepToLocation.loading && !showDepToLocation && (
					<LoadingCustomModal title="Chargement…" />
				)}
				{QuitGuard}
				{verrou.VerrouUI}
			</div>
		</div>
	)
}

export default DepFicheV2
